import {
  DEFAULT_LOCALE,
  normalizeLocale,
  type AppLocale,
} from "@lib/i18n/locales"
import { enUS } from "@lib/i18n/messages/en-US"
import { myMM } from "@lib/i18n/messages/my-MM"
import { thTH, type MessageTree } from "@lib/i18n/messages/th-TH"

const catalogs: Record<AppLocale, MessageTree> = {
  "th-TH": thTH,
  "my-MM": myMM,
  "en-US": enUS,
}

type Join<K, P> = K extends string
  ? P extends string
    ? `${K}.${P}`
    : never
  : never

type Leaves<T> = T extends object
  ? {
      [K in keyof T & string]: T[K] extends object ? Join<K, Leaves<T[K]>> : K
    }[keyof T & string]
  : never

export type MessageKey = Leaves<MessageTree>

function readPath(tree: MessageTree, key: string): string | undefined {
  const parts = key.split(".")
  let cur: unknown = tree
  for (const part of parts) {
    if (!cur || typeof cur !== "object") {
      return undefined
    }
    cur = (cur as Record<string, unknown>)[part]
  }
  return typeof cur === "string" ? cur : undefined
}

export function getMessages(locale: string | null | undefined): MessageTree {
  return catalogs[normalizeLocale(locale)]
}

export function t(
  locale: string | null | undefined,
  key: MessageKey
): string {
  const code = normalizeLocale(locale)
  return (
    readPath(catalogs[code], key) ||
    readPath(catalogs[DEFAULT_LOCALE], key) ||
    key
  )
}
